import React, { useState, useEffect } from "react";
import { Button, Snackbar, IconButton } from "@mui/material";
import AddToHomeScreenIcon from "@mui/icons-material/AddToHomeScreen";
import CloseIcon from "@mui/icons-material/Close";
import useInstallPrompt from "@shared/hooks/useInstallPrompt";

const InstallPWA = () => {
  const { canInstall, install } = useInstallPrompt();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!canInstall) return;

    const timer = setTimeout(() => {
      const dismissedDate = localStorage.getItem("installBannerDismissedDate");
      const expired =
        !dismissedDate ||
        Date.now() - parseInt(dismissedDate) > 7 * 24 * 60 * 60 * 1000;
      if (expired) setShowBanner(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, [canInstall]);

  const handleInstallClick = async () => {
    const accepted = await install();
    if (!accepted) {
      localStorage.setItem("installBannerDismissedDate", Date.now().toString());
    }
    setShowBanner(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setShowBanner(false);
    localStorage.setItem("installBannerDismissedDate", Date.now().toString());
  };

  if (!canInstall) return null;

  return (
    <Snackbar
      open={showBanner}
      autoHideDuration={15000}
      onClose={handleClose}
      message="Instala esta app para acceder más rápidamente"
      action={
        <>
          <Button
            color="primary"
            size="small"
            onClick={handleInstallClick}
            startIcon={<AddToHomeScreenIcon />}
          >
            Instalar
          </Button>
          <IconButton size="small" color="inherit" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: "#004d40",
          color: "white",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        },
      }}
    />
  );
};

export default InstallPWA;
